<form [formGroup]="form" (ngSubmit)="uploadFile()">
  <label for="fileInput">File Selection</label>
  <div class="input-group">
    <input 
      #fileInput
      formControlName="formFile"
      type="file" 
      class="form-control-file" 
      fxFlex="100" 
      class="form-control" 
      accept=".xlsx,.xls,.pdf,.txt,.csv"
      (change)="onFileSelected($event)">
      <div class="input-group-append">
        <button class="btn btn-primary" type="submit">
          Upload
        </button>
    </div>
  </div>

  <div *ngIf="fileUploadIsInvoice">
    <h6 class="mt-3">Invoice Information</h6>
    <div class="form-group row">
      <label class="col-4 col-form-label">Number</label>
      <div class="col-8"><input type="text" class="form-control invoice-info" [ngClass]="{'form-submitted': formSubmitted}" formControlName="invoiceNumber" /></div>
    </div>
    <div class="form-group row">
      <label class="col-4 col-form-label">Amount</label>
      <div class="col-8"><input type="number" class="form-control invoice-info" [ngClass]="{'form-submitted': formSubmitted}" formControlName="invoiceAmount" /></div>
    </div>
    <div class="form-group row">
      <label class="col-4 col-form-label">Invoiced On</label>
      <div class="col-8"><input type="date" class="form-control invoice-info" [ngClass]="{'form-submitted': formSubmitted}" formControlName="invoicedOn" /></div>
    </div>
    <div class="form-group row">
      <label class="col-4 col-form-label">Due Date</label>
      <div class="col-8"><input type="date" class="form-control invoice-info" [ngClass]="{'form-submitted': formSubmitted}" formControlName="invoiceDueDate" /></div>
    </div>
  </div>
</form>

<error-handler></error-handler>